// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 2.38184V16.4999L8.8 13.4999H7.88925L7.71278 14.9999H9.5V16.9999H7.47749L6.88925 21.9999H2V5.99987H8.76393L16 2.38184ZM5.87546 13.4999H4V19.9999H5.11075L5.87546 13.4999ZM20.3329 5.58566L21.04 6.29276C21.9769 7.22968 22.3684 8.63541 22.3684 9.91669C22.3684 11.198 21.9769 12.6037 21.04 13.5406L20.3329 14.2477L18.9187 12.8335L19.6258 12.1264C20.0695 11.6827 20.3684 10.8619 20.3684 9.91669C20.3684 8.97148 20.0695 8.15072 19.6258 7.70698L18.9187 6.99987L20.3329 5.58566ZM18.2496 7.25454L18.9567 7.96165C20.0375 9.0425 20.0375 10.7949 18.9567 11.8758L18.2496 12.5829L16.8354 11.1687L17.5425 10.4615C17.8423 10.1617 17.8423 9.67566 17.5425 9.37586L16.8354 8.66875L18.2496 7.25454Z"}}]};

const LoudspeakerFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'loudspeaker-filled',
    ref,
    icon: element,
  },
));

LoudspeakerFilledIcon.displayName = 'LoudspeakerFilledIcon';

export default LoudspeakerFilledIcon;
